// Верхняя атмосфера мобильного экрана: синее свечение от кромки + пиксельный
// дизер поверх него. В макетах хендоффа это два абсолютных слоя в самом верху
// экрана, под контентом и под хедером, оба pointer-events:none.
//
// Живёт на уровне ОБОЛОЧКИ, а не экрана: у Portfolio экран сам прокручивается,
// и слой, положенный внутрь него, уезжал бы вместе с лентой.

import type { CSSProperties } from 'react'
import styles from './MobileScreenGlow.module.css'

export function MobileScreenGlow({
  glow = 200,
  dither = 200,
  intensity = 1,
}: {
  /** Высота свечения. Discover 200, Portfolio 240. */
  glow?: number
  /** Высота дизера. Discover 200, Portfolio 180. */
  dither?: number
  /** 0..1 — сила свечения и дизера. */
  intensity?: number
}) {
  return (
    <>
      <span
        className={styles.glow}
        style={
          {
            '--glow-h': `${glow}px`,
            '--glow-a': `${Math.round(28 * intensity)}%`,
          } as CSSProperties
        }
        aria-hidden="true"
      />
      <span
        className={styles.dither}
        style={
          {
            '--dither-h': `${dither}px`,
            opacity: 0.12 * intensity,
          } as CSSProperties
        }
        aria-hidden="true"
      />
    </>
  )
}
